import { updateObject } from "../../helpers/common/utility";
import * as actionTypes from "../actions/types";

const initialState = {
  history: [],
};

const setHistory = (state, action) => {
  return updateObject(state, {
    history: action.data,
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_FARMASI_HISTORY:
      return setHistory(state, action);
    default:
      return state;
  }
};

export default reducer;
